import OwnerFeatureCard from "@/components/v2/atoms/landing/about/OwnerFeatureCard";
import { TranslationKey } from "@/types/translations";
import { Building2, Camera, HeadphonesIcon } from "lucide-react";

interface AboutPropertyOwnersProps {
  translate: (key: TranslationKey) => string;
  handleWhatsAppClick: () => void;
}

const features = [
  {
    icon: <Building2 className="w-8 h-8 text-brand-primary" />,
    titleKey: "about.property_owners.management.title",
    descriptionKey: "about.property_owners.management.description",
  },
  {
    icon: <Camera className="w-8 h-8 text-brand-primary" />,
    titleKey: "about.property_owners.marketing.title",
    descriptionKey: "about.property_owners.marketing.description",
  },
  {
    icon: <HeadphonesIcon className="w-8 h-8 text-brand-primary" />,
    titleKey: "about.property_owners.support.title",
    descriptionKey: "about.property_owners.support.description",
  },
];

const AboutPropertyOwners = ({
  translate,
  handleWhatsAppClick,
}: AboutPropertyOwnersProps) => (
  <section className="py-16 md:py-20 bg-gray-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12 md:mb-16">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
          {translate("about.property_owners.title")}
        </h2>

        <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
          {translate("about.property_owners.subtitle")}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-12 md:mb-16">
        {features.map(({ icon, titleKey, descriptionKey }) => (
          <OwnerFeatureCard
            key={titleKey}
            icon={icon}
            title={translate(titleKey as TranslationKey)}
            description={translate(descriptionKey as TranslationKey)}
          />
        ))}
      </div>

      <div className="text-center">
        <button
          onClick={handleWhatsAppClick}
          className="inline-block bg-brand-primary text-white px-6 md:px-8 py-3 rounded-lg hover:bg-brand-primary-hover transition-colors duration-200 font-semibold"
        >
          {translate("about.property_owners.cta")}
        </button>
      </div>
    </div>
  </section>
);

export default AboutPropertyOwners;
